<template>
  <v-dialog
    :max-width="maxWidth"
    v-model="show"
    persistent
    transition="dialog-bottom-transition"
  >
    <v-card>
      <v-toolbar dark color="primary">
        <v-btn icon dark @click="show = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <v-toolbar-title>Evoluciones</v-toolbar-title>
      </v-toolbar>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="warning" @click.stop="imprimir">Imprimir</v-btn>
        <v-btn color="error" @click.stop="show = false">Salir</v-btn>
      </v-card-actions>
      <v-card-text v-for="(evolucion, i) in evoluciones" :key="i">
        <v-row class="my-4 mx-1">
          <h3>Profesional: {{ evolucion.nomProfesional }}</h3>
        </v-row>
        <v-row class="my-2 mx-1">
          <h3>Fecha: {{ evolucion.fechaHoraString }}</h3>
        </v-row>
        <v-row
          v-if="$store.state.usuario.institucion.idInstitucion === 436"
          class="mb-2 mt-4 mx-1"
        >
          <h3>
            Es control de niño sano:
            {{ `${evolucion.controlNinoSano ? "Si" : "No"}` }}
          </h3>
        </v-row>
        <template v-if="!evolucion.usaPlantilla">
          <v-row class="mt-4 mx-1">
            <h3>Evolución:</h3>
          </v-row>
          <v-row class="ml-1">
            <div v-html="evolucion.texto" class="texto-evolucion"></div>
          </v-row>
        </template>
        <template v-else>
          <div class="mt-4">
            <template v-for="([key, value], index) in camposJson(evolucion)">
              <v-row v-if="value" class="my-2 mx-1" :key="index">
                <h3>{{ camelToLabel(key) }}: {{ value }}</h3>
              </v-row>
            </template>
          </div>
        </template>
        <v-divider></v-divider>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="warning" @click.stop="imprimir">Imprimir</v-btn>
        <v-btn color="error" @click.stop="show = false">Salir</v-btn>
      </v-card-actions>
    </v-card>
    <ImprimirEvolucionesFecha
      :visible="showImprimirEvoluciones"
      :evoluciones="evoluciones"
      :paciente="paciente"
      @close="showImprimirEvoluciones = false"
    ></ImprimirEvolucionesFecha>
  </v-dialog>
</template>
<style scoped>
.multi-line {
  white-space: pre-line;
}
.v-dialog__content {
  align-items: left;
  justify-content: left;
}
.texto-evolucion {
  font-size: 16px;
  font-weight: 500;
  color: #000;
  margin-top: 1.5rem;
  line-height: 1.5;
  white-space: pre-line;
}
</style>
<script>
import axios from "../../axios-auth.js";
import ImprimirEvolucionesFecha from "../HistClin/ImprimirEvolucionesFecha.vue";
export default {
  data: (vm) => ({
    maxWidth: "100%",
    base64: null,
    showImprimirEvoluciones: false,
  }),
  props: ["visible", "evoluciones", "paciente"],
  computed: {
    show: {
      get() {
        if (this.$store.state.videollamada == true) this.maxWidth = "68%";
        else this.maxWidth = "100%";
        if (this.visible) this.getLogoUrl();
        return this.visible;
      },
      set(value) {
        if (!value) {
          document.getElementsByClassName("v-dialog--active")[0].scrollTop = 0;
          this.$emit("close");
        }
      },
    },
  },
  methods: {
    camelToLabel(str) {
      return str
        .replace(/([A-Z])/g, " $1") // agrega espacio antes de mayúsculas
        .replace(/^./, (s) => s.toUpperCase()); // capitaliza la primera letra
    },
    camposJson(evolucion) {
      return evolucion.evolucionJson
        ? Object.entries(JSON.parse(evolucion.evolucionJson))
        : [];
    },
    getLogoUrl() {
      let self = this;

      axios
        .get("/HistoriaClinica/GetLogo?", {
          params: {
            idInstitucion: this.$store.state.usuario.institucion.idInstitucion,
          },
        })
        .then((response) => {
          self.base64 = response.data;
        })
        .catch((error) => {});
    },
    imprimir() {
      this.showImprimirEvoluciones = true;
    },
  },
  components: {
    ImprimirEvolucionesFecha,
  },
};
</script>
